import { natoSans } from "./fontFile/NatoSans";
import { natoBengali } from "./fontFile/NatoSansBengali";
import { natoMalyalam } from "./fontFile/NatoSansMalyalam";
import { natoPunjabi } from "./fontFile/NatoSansPunjabi";
import { NatoSansUrdu } from "./fontFile/NatoSansUrdu";
import { NatoSansTamil } from "./fontFile/NatoSansTamil";
import { natoGujrati } from "./fontFile/NatoSansGujrati";
import { natoKannada } from "./fontFile/NatoSansKannada";
import { natoOdia } from "./fontFile/NatoSansOdia";

export const addFontsToPDF = (doc, language) => {
  //  
  switch (language) {
    case "Hindi":
      doc.addFileToVFS("NotoSans-Regular.ttf", natoSans);
      doc.addFont("NotoSans-Regular.ttf", "NotoSans", "normal");
      break;

    case "Tamil":
      doc.addFileToVFS("NotoSansTamil-Regular.ttf", NatoSansTamil);
      doc.addFont("NotoSansTamil-Regular.ttf", "NotoSansTamil", "normal");
      break;

    case "Bengali":
      doc.addFileToVFS("NotoSansBengali-Regular.ttf", natoBengali);
      doc.addFont("NotoSansBengali-Regular.ttf", "NotoSansBengali", "normal");
      break;

    case "Punjabi":
      doc.addFileToVFS("NotoSansGurmukhi-Regular.ttf", natoPunjabi);
      doc.addFont("NotoSansGurmukhi-Regular.ttf", "NotoSansGurmukhi", "normal");
      break;

    case "Gujarati":
      doc.addFileToVFS("NotoSansGujarati-Regular.ttf", natoGujrati);
      doc.addFont("NotoSansGujarati-Regular.ttf", "NotoSansGujarati", "normal");
      break;

    case "Kannada":
      doc.addFileToVFS("NotoSerifKannada-Regular.ttf", natoKannada);
      doc.addFont("NotoSerifKannada-Regular.ttf", "NotoSerifKannada", "normal");
      break;

    case "Oriya":
      doc.addFileToVFS("NotoSansOriya-Regular.ttf", natoOdia);
      doc.addFont("NotoSansOriya-Regular.ttf", "NotoSansOriya", "normal");
      break;

    case "Urdu":
      doc.addFileToVFS("NotoSansArabic-Regular.ttf", NatoSansUrdu);
      doc.addFont("NotoSansArabic-Regular.ttf", "NotoSansArabic", "normal");
      break;

    case "Malayalam":
      doc.addFileToVFS("NotoSansMalayalam-Regular.ttf", natoMalyalam);
      doc.addFont(
        "NotoSansMalayalam-Regular.ttf",
        "NotoSansMalayalam",
        "normal"
      );
      break;

    default:
      // Use default font or handle unsupported language
      break;
  }
};


export const getFontForText = (pdf, text) => {
  if (/\p{Script=Devanagari}/u.test(text)) {
    addFontsToPDF(pdf, "Hindi");
    return "NotoSans";
  } else if (/\p{Script=Tamil}/u.test(text)) {
    addFontsToPDF(pdf, "Tamil");
    return "NotoSansTamil";
  } else if (/\p{Script=Gujarati}/u.test(text)) {
    addFontsToPDF(pdf, "Gujarati");
    return "NotoSansGujarati";
  } else if (/\p{Script=Bengali}/u.test(text)) {
    addFontsToPDF(pdf, "Bengali");
    return "NotoSansBengali";
  } else if (/\p{Script=Gurmukhi}/u.test(text)) {
    addFontsToPDF(pdf, "Punjabi");
    return "NotoSansGurmukhi";
  } else if (/\p{Script=Arabic}/u.test(text)) {
    addFontsToPDF(pdf, "Urdu");
    return "NotoSansArabic";
  } else if (/\p{Script=Malayalam}/u.test(text)) {
    addFontsToPDF(pdf, "Malayalam");
    return "NotoSansMalayalam";
  } else if (/\p{Script=Oriya}/u.test(text)) {
    addFontsToPDF(pdf, "Oriya");
    return "NotoSansOriya";
  } else if (/\p{Script=Kannada}/u.test(text)) {
    addFontsToPDF(pdf, "Kannada");
    return "NotoSerifKannada";
  }
  return "NotoSans"; // Default font
};





export const countPlatforms = (serverresponse, analyticsData) => {
  const platformCounts = {};
  (serverresponse || analyticsData || []).forEach((item) => {
    platformCounts[item.platform] = (platformCounts[item.platform] || 0) + 1;
  });
  //  
  return platformCounts;
};

export const countLanguages = (serverresponse, analyticsData) => {
  const languageCounts = {};
  (serverresponse || analyticsData || []).forEach((item) => {
    if (item.languages && item.languages != "none") {
      languageCounts[item.languages] =
        (languageCounts[item.languages] || 0) + 1;
    }
  });
  //  
  return languageCounts;
};

// Function to count sentiment
export const countSentiment = (serverresponse, analyticsData) => {
  const sentimentCounts = {};

  (serverresponse || analyticsData || []).forEach((item) => {
    // Check for sentiment first, then prediction as fallback with safe navigation
    const sentimentValue = item.sentiment || item.analysis?.prediction || [];

    if (sentimentValue) {
      sentimentCounts[sentimentValue] = (sentimentCounts[sentimentValue] || 0) + 1;
    }
  });

  return sentimentCounts;
};


// Function to count sections
export const countSections = (serverresponse, analyticsData) => {
  //  
  const sectionCounts = {};
  (serverresponse || []).forEach((item) => {
    (item.sections || []).forEach((section) => {
      sectionCounts[section] = (sectionCounts[section] || 0) + 1;
    });
  });
  //  
  return sectionCounts;
};
